exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-day-schedule-js": () => import("./../../../src/templates/day-schedule.js" /* webpackChunkName: "component---src-templates-day-schedule-js" */)
}

